export default {
  "pages.groups.members.selectUsers": "搜索并勾选要添加的用户（可多选）",
  "pages.groups.members.addBatchSuccess": "已添加 {count} 名成员",
  "pages.groups.members.addBatchFailed": "{count} 名成员添加失败",
  "pages.groups.members.addActionCount": "添加 {count} 人",
  "pages.platforms.form.loginUrl.pattern": "走统一认证的平台只允许 http/https；App 拉起链接请先勾选「外部平台」",
  "pages.platforms.form.loginUrl.banned": "不允许该协议",
  "pages.platforms.form.loginUrl.invalid": "请输入带协议的完整地址",
  "pages.me.switchAccount": "切换账号",
  "pages.me.accountCount": "{count} 个账号",
  "pages.platforms.form.isExternal.label": "外部平台",
  "pages.platforms.form.isExternal.tooltip": "ADP、外部 ERP 这类不走统一认证的系统。只在「我的平台」里放一个入口链接，用户点开后要在对方站点单独登录；不能作为 OAuth 客户端。",
  "pages.launcher.external.title": "前往「{name}」",
  "pages.launcher.external.content": "这个系统不支持自动登录，打开后需要用它自己的账号密码登录。",
  "pages.launcher.external.ok": "继续前往",
  "pages.me.otherAccounts": "其他账号",
  "pages.me.preferences": "偏好",
  "pages.myPlatforms.greeting.night": "夜深了",
  "pages.myPlatforms.greeting.morning": "早上好",
  "pages.myPlatforms.greeting.afternoon": "下午好",
  "pages.myPlatforms.greeting.evening": "晚上好",
  "pages.myPlatforms.count": "{count} 个系统可用",
  "pages.user.login.choose.signedOut": "已退出",
  "pages.user.login.sessionExpired": "该账号的登录状态已过期，请重新登录",
  "pages.platforms.form.logoUrl.label": "平台图标",
  "pages.platforms.form.logoUrl.tooltip": "选填。显示在用户「我的平台」的入口上。留空则用平台名首字配主色生成图标。",
  "pages.platforms.form.logoUrl.pattern": "请输入带 http/https 的完整地址",
  "pages.platforms.form.loginUrl.tooltip": "选填。填了这个平台才会出现在用户的「我的平台」里，点击即跳转到这个地址发起登录。App、手持设备这类没有网页入口的平台留空即可。",
  "pages.register.title": "创建账号",
  "pages.register.subtitle": "注册 Korsmet 统一认证账号",
  "pages.register.haveAccount.prefix": "已有账号？",
  "pages.register.haveAccount.action": "去登录",
  "pages.platforms.form.brandColor.label": "App 图标背景色",
  "pages.platforms.form.brandColor.tooltip": "仅用于 App 列表中的图标背景，留空使用默认蓝色。登录页和授权页使用统一认证的默认配色。",
  "pages.platforms.form.brandColor.pattern": "请填 #RRGGBB 格式的色值",
  "pages.oauth.authorize.progress.title": "正在登录到「{platform}」",
  "pages.oauth.authorize.progress.subtitle": "正在请求授权，请稍候",
  "pages.oauth.authorize.progress.hint": "完成后会自动返回该平台",
  "pages.user.login.choose.title": "选择账号",
  "pages.user.login.choose.subtitle": "继续使用 Korsmet 统一认证",
  "pages.user.login.choose.forPlatform": "继续前往「{platform}」",
  "pages.user.login.choose.another": "使用其他账号",
  "pages.user.login.choose.privacy": "不是你的设备？用无痕窗口登录，账号不会留在这台电脑上。",
  "pages.user.login.identify.title": "登录",
  "pages.user.login.identify.subtitle": "使用你的 Korsmet 账号",
  "pages.user.login.next": "下一步",
  "pages.user.login.backToChoose": "返回选择账号",
  "pages.user.login.password.title": "输入密码",
  "pages.user.login.password.subtitle": "欢迎回来",
  "pages.user.login.password.swap": "更换",
  "pages.user.login.submitAndContinue": "登录并继续",
  "pages.user.login.failure": "账号或密码不正确，请重试",
  "pages.user.login.register.prefix": "没有账号？",
  "pages.user.login.register.action": "去注册",
  "pages.oauth.authorize.choose.title": "选择账号",
  "pages.oauth.authorize.choose.subtitle": "继续前往「{platform}」",
  "pages.oauth.authorize.choose.another": "使用其他账号",
  "pages.oauth.authorize.confirm.toPlatform": "登录到「{platform}」",
  "pages.oauth.authorize.confirm.withAccount": "使用你的 Korsmet 账号",
  "pages.oauth.authorize.confirm.notYou": "不是你？",
  "pages.oauth.authorize.confirm.scopeProfile": "「{platform}」将获取你的姓名和邮箱",
  "pages.oauth.authorize.confirm.scopeId": "以及你在该平台的账号标识",
  "pages.oauth.authorize.confirm.fine": "Korsmet Auth 只负责确认你的身份，不会把密码交给业务平台。",
  "pages.oauth.authorize.actions.cancel": "取消",
  "pages.oauth.authorize.actions.continue": "继续",
  'pages.user.login.platformFallback': '目标平台',
  "pages.user.login.oauth.intro": "登录后返回「{platform}」",
  'pages.user.login.oauth.validating': '正在校验账号凭证...',
  'pages.user.login.oauth.success': '登录成功，正在跳转「{platform}」授权页面...',
  'pages.user.login.oauth.failure': '登录失败，请检查账号或稍后重试',
  'pages.user.login.subtitle': '统一认证与权限控制平台',
  'pages.user.login.submit': '登录',
  'pages.user.login.register': '没有账号？去注册',
  'pages.user.login.placeholder.identifier': '请输入用户名或邮箱',
  'pages.user.login.validation.identifier': '请输入用户名或邮箱',
  'pages.user.login.placeholder.password': '请输入密码',
  'pages.user.login.validation.password': '请输入密码',
  'pages.user.login.autoLogin': '自动登录',
  'pages.register.submit': '注册',
  'pages.register.success': '注册成功！请等待管理员审核启用您的账号。',
  'pages.register.failure': '注册失败，请稍后重试',
  'pages.register.haveAccount': '已有账号？去登录',
  'pages.register.notice.title': '注册说明',
  "pages.register.notice.description": "注册后账号默认停用，需要管理员审核启用后才能登录。",
  'pages.register.username.placeholder': '用户名（3-20个字符）',
  'pages.register.username.required': '请输入用户名',
  'pages.register.username.min': '用户名至少3个字符',
  'pages.register.username.max': '用户名最多20个字符',
  'pages.register.username.pattern': '用户名只能包含字母、数字和下划线',
  'pages.register.fullName.placeholder': '真实姓名',
  'pages.register.fullName.required': '请输入真实姓名',
  'pages.register.fullName.min': '姓名至少2个字符',
  'pages.register.email.placeholder': '邮箱（可选）',
  'pages.register.email.invalid': '请输入有效的邮箱地址',
  'pages.register.password.placeholder': '密码（至少8个字符）',
  'pages.register.password.required': '请输入密码',
  'pages.register.password.min': '密码至少8个字符',
  'pages.register.confirmPassword.placeholder': '确认密码',
  'pages.register.confirmPassword.required': '请确认密码',
  'pages.register.confirmPassword.mismatch': '两次输入的密码不一致',
  'pages.oauth.authorize.brandTitle': 'Korsmet 统一认证',
  'pages.oauth.authorize.processing': '正在为您处理授权请求',
  'pages.oauth.authorize.confirm.chooseTitle': '选择账号',
  'pages.oauth.authorize.confirm.chooseDescription': '选择一个账号登录到该平台',
  'pages.oauth.authorize.confirm.currentTag': '当前',
  'pages.oauth.authorize.actions.useAnotherAccount': '使用其他账号',
  'pages.oauth.authorize.confirm.title': '确认登录账号',
  'pages.oauth.authorize.confirm.description': '是否继续使用当前账号登录到第三方平台？',
  'pages.oauth.authorize.confirm.platform': '目标平台：{platform}',
  'pages.oauth.authorize.confirm.nameLabel': '当前账号姓名',
  'pages.oauth.authorize.confirm.emailLabel': '当前账号邮箱',
  'pages.oauth.authorize.confirm.email': '当前账号邮箱：{email}',
  'pages.oauth.authorize.actions.continueAccount': '继续使用此账号',
  'pages.oauth.authorize.actions.switchAccount': '更换账号',
  'pages.oauth.authorize.actions.backLogin': '返回登录',
  'pages.oauth.authorize.actions.retry': '重试',
  'pages.oauth.authorize.steps.check.title': '检查登录状态',
  'pages.oauth.authorize.steps.check.description': '验证用户身份',
  'pages.oauth.authorize.steps.confirm.title': '确认账号',
  'pages.oauth.authorize.steps.confirm.description': '确认登录账号',
  'pages.oauth.authorize.steps.authorize.title': '生成授权码',
  'pages.oauth.authorize.steps.authorize.description': '返回业务平台',
  'pages.oauth.authorize.status.redirectLogin': '未登录，正在跳转到登录页...',
  'pages.oauth.authorize.status.redirectLoginExpired': '登录状态已过期，正在跳转到登录页...',
  'pages.oauth.authorize.status.authorizing': '正在请求授权...',
  'pages.oauth.authorize.status.success': '授权成功，正在跳转到业务平台...',
  'pages.oauth.authorize.error.invalidResponseType': '无效的 response_type 参数，必须为 "code"',
  'pages.oauth.authorize.error.missingClientId': '缺少 client_id 参数',
  'pages.oauth.authorize.error.missingRedirectUri': '缺少 redirect_uri 参数',
  'pages.oauth.authorize.error.http': '授权失败 (HTTP {status})',
  'pages.oauth.authorize.error.missingRedirectUrl': '后端未返回重定向 URL',
  'pages.oauth.authorize.error.unknownResponse': '未知的响应类型',
  'pages.oauth.authorize.error.failed': '授权失败',
  'pages.oauth.authorize.error.title.params': '参数错误',
  'pages.oauth.authorize.error.title.authorize': '授权失败',
  'pages.oauth.authorize.params.title': '详细信息',
  'pages.oauth.authorize.params.errorCode': '错误代码:',
  'pages.oauth.authorize.params.rawMessage': '原始信息:',
  'pages.oauth.authorize.error.noRedirectUri': '该平台还没有登记任何回调地址，请联系管理员在「平台管理」里补上。',
  'pages.oauth.authorize.error.redirectUriNotAllowed': '回调地址不在该平台登记的白名单内，请联系管理员核对（大小写、结尾斜杠都要完全一致）。',
  'pages.oauth.authorize.error.noPlatformAccess': '当前账号未被授权访问该平台，请联系管理员开通。',
  'pages.oauth.authorize.error.platformNotFound': '平台不存在或已停用，请核对 client_id。',
  'pages.oauth.authorize.error.platformUnavailable': '该平台已停用。',
  'pages.oauth.authorize.error.accountUnavailable': '当前账号已被停用，请联系管理员。',
  'pages.oauth.authorize.params.platform': '平台：',
  'pages.oauth.authorize.params.redirectUri': '回调地址：',
  'pages.oauth.authorize.params.scope': '权限范围：',
  'pages.oauth.authorize.info.title': '授权信息',
  'pages.404.subTitle': '抱歉，您访问的页面不存在。',
  'pages.404.buttonText': '返回首页',
  'pages.common.status.enabled': '启用',
  'pages.common.status.disabled': '停用',
  'pages.common.cancel': '取消',
  'pages.common.confirm': '确认',
  'pages.common.roles.admin': '管理员',
  'pages.common.roles.user': '普通用户',
  'pages.common.unknownPlatform': '未知平台',
  'pages.common.notProvided': '未填写',
  'pages.common.notAvailable': '—',
  'pages.common.systemCreated': '系统创建',
  'pages.common.platformMissing': '关联平台不存在（ID: {id}）',
  'pages.common.neverLoggedIn': '从未登录',
  'pages.common.loading': '加载中…',
  'pages.users.title': '用户管理',
  'pages.users.loadError': '获取用户列表失败，请稍后重试。',
  'pages.platforms.loadError': '获取平台列表失败。',
  'pages.users.assignmentsLoadError': '获取角色分配失败，请稍后重试。',
  'pages.users.actions.create': '添加用户',
  'pages.users.actions.edit': '编辑',
  'pages.users.actions.assign': '授权',
  'pages.users.actions.resetPassword': '修改密码',
  'pages.users.actions.deactivate': '停用',
  'pages.users.actions.revoke': '撤销授权',
  'pages.users.searchPlaceholder': '搜索用户（姓名、用户名、邮箱）',
  'pages.users.table.username': '用户名',
  'pages.users.table.fullName': '姓名',
  'pages.users.table.email': '邮箱',
  'pages.users.table.globalRole': '全局角色',
  'pages.users.table.origin': '导入来源',
  'pages.users.table.status': '状态',
  'pages.users.table.lastLogin': '最近登录',
  'pages.users.table.actions': '操作',
  'pages.users.revokeConfirm.title': '确认撤销平台授权',
  'pages.users.revokeConfirm.content': '确定要撤销用户对“{platformName}”的访问授权吗？撤销后，该用户将无法登录此平台。',
  'pages.users.revokeConfirm.ok': '确认撤销',
  'pages.users.revokeConfirm.success': '平台授权已撤销',
  'pages.profile.profileUpdated': '个人资料已更新',
  'pages.profile.passwordUpdated': '密码已更新，请使用新密码登录',
  'pages.profile.basicInfo.title': '基本资料',
  'pages.profile.basicInfo.description': '更新您的姓名和联系邮箱。邮箱用于接收通知和安全提醒，可留空。',
  'pages.profile.security.title': '安全设置',
  'pages.profile.security.description': '建议定期更新密码，并使用至少 8 个字符的强密码组合。',
  'pages.profile.form.username.label': '用户名',
  'pages.profile.form.fullName.label': '姓名',
  'pages.profile.form.fullName.required': '请输入姓名',
  'pages.profile.form.fullName.min': '姓名至少 2 个字符',
  'pages.profile.form.fullName.placeholder': '请输入姓名',
  'pages.profile.form.email.label': '邮箱',
  'pages.profile.form.email.invalid': '请输入有效的邮箱地址',
  'pages.profile.form.email.placeholder': '可选，邮箱用于接收通知',
  'pages.profile.form.basic.submit': '保存资料',
  'pages.profile.form.currentPassword.label': '当前密码',
  'pages.profile.form.currentPassword.required': '请输入当前密码',
  'pages.profile.form.currentPassword.placeholder': '请输入当前密码',
  'pages.profile.form.newPassword.label': '新密码',
  'pages.profile.form.newPassword.required': '请输入新密码',
  'pages.profile.form.newPassword.min': '密码至少 8 个字符',
  'pages.profile.form.newPassword.placeholder': '请输入新密码',
  'pages.profile.form.confirmPassword.label': '确认新密码',
  'pages.profile.form.confirmPassword.required': '请再次输入新密码',
  'pages.profile.form.confirmPassword.mismatch': '两次输入的密码不一致',
  'pages.profile.form.confirmPassword.placeholder': '请再次输入新密码',
  'pages.profile.form.password.submit': '更新密码',
  'pages.dashboard.error.unknown': '未知错误',
  'pages.dashboard.loadError': '加载概览数据失败：{detail}',
  'pages.dashboard.assignmentsError': '加载平台授权信息失败，请稍后重试',
  'pages.dashboard.quickLogin.missingSlug': '未找到平台标识，无法发起登录',
  'pages.dashboard.assignments.empty': '您尚未获得任何业务平台的访问权限',
  'pages.dashboard.assignments.contactAdmin': '如需开通特定业务系统权限，请联系系统管理员。',
  'pages.dashboard.myPlatforms.title': '我的平台',
  "pages.dashboard.myPlatforms.description": "点击图标进入对应系统。",
  'pages.dashboard.platform.unnamed': '未命名平台',
  'pages.dashboard.platform.noDescription': '暂无平台描述',
  'pages.dashboard.platform.slug': '平台标识：',
  'pages.dashboard.platform.account': '您的平台账号：',
  'pages.dashboard.platform.accountAuto': '平台账号将自动分配',
  'pages.dashboard.actions.quickLogin': '快速登录',
  'pages.dashboard.actions.visitPortal': '访问门户',
  'pages.dashboard.overview.title': '系统概览',
  'pages.dashboard.overview.userCount': '系统用户',
  'pages.dashboard.overview.activePlatforms': '活跃平台',
  'pages.dashboard.overview.roles': '定义角色',
  'pages.dashboard.recentUsers.title': '最近登录用户',
  'pages.dashboard.recentUsers.empty': '暂无登录记录',
  'pages.dashboard.recentUsers.lastLogin': '最近登录：{time}',
  'pages.dashboard.recentUsers.never': '从未登录',
  'pages.roles.scope.global': '全局',
  'pages.roles.scope.platform': '平台',
  'pages.roles.loadError': '获取角色列表失败，请稍后重试',
  'pages.roles.updateSuccess': '角色已更新',
  'pages.roles.createSuccess': '角色创建成功',
  'pages.roles.table.name': '角色名称',
  'pages.roles.table.slug': '标识',
  'pages.roles.table.scope': '类型',
  'pages.roles.table.description': '描述',
  'pages.roles.table.actions': '操作',
  'pages.roles.headerTitle': '角色管理',
  'pages.roles.searchPlaceholder': '搜索角色名称、标识或描述',
  'pages.roles.actions.create': '添加角色',
  'pages.roles.modal.editTitle': '编辑角色',
  'pages.roles.modal.createTitle': '添加角色',
  'pages.roles.form.name.label': '角色名称',
  'pages.roles.form.name.placeholder': '请输入角色名称',
  'pages.roles.form.name.required': '请输入角色名称',
  'pages.roles.form.slug.label': '角色标识',
  'pages.roles.form.slug.placeholder': '请输入角色标识',
  'pages.roles.form.slug.required': '请输入角色标识',
  'pages.roles.form.slug.pattern': '仅支持小写字母、数字和短横线',
  'pages.roles.form.scope.label': '角色类型',
  'pages.roles.form.scope.placeholder': '请选择角色类型',
  'pages.roles.form.scope.required': '请选择角色类型',
  'pages.roles.form.scope.global': '全局角色',
  'pages.roles.form.scope.platform': '平台角色',
  'pages.roles.form.description.label': '描述',
  'pages.roles.form.description.placeholder': '此角色用于控制用户访问平台的权限，不影响平台内的业务权限（可选）',
  'pages.groups.headerTitle': '用户组管理',
  'pages.groups.searchPlaceholder': '搜索组名称或标识',
  'pages.groups.actions.create': '新建用户组',
  'pages.groups.actions.members': '成员',
  'pages.groups.actions.platforms': '平台',
  'pages.groups.actions.archive': '归档',
  'pages.groups.table.name': '组名称',
  'pages.groups.table.slug': '标识',
  'pages.groups.table.description': '描述',
  'pages.groups.table.members': '成员数',
  'pages.groups.table.platforms': '授权平台',
  'pages.groups.table.status': '状态',
  'pages.groups.table.actions': '操作',
  'pages.groups.optionsLoadError': '加载选项失败',
  'pages.groups.loadError': '获取用户组失败',
  'pages.groups.archive.confirm': '确认归档该用户组？',
  'pages.groups.archiveSuccess': '用户组已归档',
  'pages.groups.archiveError': '归档失败',
  'pages.groups.modal.editTitle': '编辑用户组',
  'pages.groups.modal.createTitle': '新建用户组',
  'pages.groups.modal.updateSuccess': '用户组已更新',
  'pages.groups.modal.createSuccess': '用户组已创建',
  'pages.groups.modal.submitError': '保存失败',
  'pages.groups.form.name.label': '组名称',
  'pages.groups.form.name.placeholder': '请输入组名称',
  'pages.groups.form.name.required': '请填写组名称',
  'pages.groups.form.slug.label': '组标识',
  'pages.groups.form.slug.placeholder': '请输入唯一标识，建议使用英文或短横线',
  'pages.groups.form.slug.required': '请填写组标识',
  'pages.groups.form.description.label': '描述',
  'pages.groups.form.description.placeholder': '请输入描述（可选）',
  'pages.groups.members.title': '管理「{name}」成员',
  'pages.groups.members.titleFallback': '管理成员',
  'pages.groups.members.loadError': '获取成员列表失败',
  'pages.groups.members.selectUser': '选择要添加的用户',
  'pages.groups.members.role.owner': '管理员',
  'pages.groups.members.role.member': '成员',
  'pages.groups.members.addAction': '添加',
  'pages.groups.members.columns.name': '姓名',
  'pages.groups.members.columns.role': '角色',
  'pages.groups.members.columns.actions': '操作',
  'pages.groups.members.removeConfirm': '确认移除此成员？',
  'pages.groups.members.remove': '移除',
  'pages.groups.members.addSuccess': '成员已添加',
  'pages.groups.members.addError': '添加成员失败',
  'pages.groups.members.removeSuccess': '成员已移除',
  'pages.groups.members.removeError': '移除失败',
  'pages.groups.platforms.title': '管理「{name}」的平台授权',
  'pages.groups.platforms.titleFallback': '管理平台授权',
  'pages.groups.platforms.loadError': '获取平台授权失败',
  'pages.groups.platforms.selectPlatform': '选择要授权的平台',
  'pages.groups.platforms.addAction': '添加平台',
  'pages.groups.platforms.columns.name': '平台',
  'pages.groups.platforms.columns.actions': '操作',
  'pages.groups.platforms.removeConfirm': '确认移除此平台？',
  'pages.groups.platforms.remove': '移除',
  'pages.groups.platforms.addSuccess': '平台授权已添加',
  'pages.groups.platforms.addError': '添加平台失败',
  'pages.groups.platforms.removeSuccess': '平台授权已移除',
  'pages.groups.platforms.removeError': '移除平台失败',
  'pages.platforms.table.apiKey': 'API Key',
  'pages.platforms.labels.apiKey': 'API Key：',
  'pages.platforms.labels.apiSecret': 'API Secret：',
  'pages.users.deactivateConfirm.title': '确认停用用户',
  'pages.users.deactivateConfirm.content': '确定要停用用户“{name}”吗？',
  'pages.users.deactivateConfirm.success': '用户已停用',
  'pages.users.drawer.titleWithName': '{name} 的平台访问授权',
  'pages.users.drawer.title': '平台访问授权',
  'pages.users.drawer.description': '以下为该用户可以通过统一认证访问的业务平台列表。',
  'pages.users.drawer.assignButton': '授权平台',
  'pages.users.drawer.originLabel': '导入来源：',
  'pages.users.drawer.originPlatform': '{name}（{slug}）',
  'pages.users.drawer.originSystem': '系统创建 / 自助注册',
  'pages.users.drawer.methodLabel': '添加方式：',
  'pages.users.drawer.methodImported': '平台导入用户，使用对应平台密钥登录',
  'pages.users.drawer.methodDefault': '系统账号，使用全局密钥登录',
  'pages.users.drawer.alertTitle': '权限说明',
  'pages.users.drawer.alertDescription': 'Korsmet Auth 只管理用户能否登录业务平台。平台内的具体权限（如功能访问、数据权限）由各业务系统独立管理。',
  'pages.users.drawer.table.platform': '业务平台',
  'pages.users.drawer.table.platformUserId': '平台用户 ID',
  'pages.users.drawer.table.assignedAt': '授权时间',
  'pages.users.drawer.empty': '暂无平台授权',
  'pages.users.messages.updateSuccess': '用户已更新',
  'pages.users.messages.createSuccess': '用户创建成功',
  'pages.users.messages.passwordRequired': '请设置初始密码',
  'pages.users.messages.passwordResetSuccess': '密码已修改',
  'pages.users.form.editTitle': '编辑用户',
  'pages.users.form.createTitle': '添加用户',
  'pages.users.form.username.label': '用户名',
  'pages.users.form.username.placeholder': '请输入用户名',
  'pages.users.form.username.required': '请输入用户名',
  'pages.users.form.username.min': '用户名至少 3 个字符',
  'pages.users.form.password.label': '密码',
  'pages.users.form.password.placeholder': '请输入密码',
  'pages.users.form.password.required': '请输入密码',
  'pages.users.form.password.min': '密码至少 8 个字符',
  'pages.users.form.fullName.label': '姓名',
  'pages.users.form.fullName.placeholder': '请输入姓名',
  'pages.users.form.fullName.required': '请输入姓名',
  'pages.users.form.email.label': '邮箱',
  'pages.users.form.email.placeholder': '请输入邮箱（可选）',
  'pages.users.form.email.invalid': '请输入有效的邮箱地址',
  'pages.users.form.globalRole.label': '全局角色',
  'pages.users.form.globalRole.placeholder': '请选择全局角色（可选）',
  'pages.users.form.addFrom.label': '导入来源平台',
  'pages.users.form.addFrom.placeholder': '请选择导入来源平台（可选）',
  'pages.users.form.status.label': '状态',
  'pages.users.passwordModal.title': '修改 {name} 的密码',
  'pages.users.passwordModal.titleWithoutName': '修改用户密码',
  'pages.users.passwordModal.selfNotAllowed': '不能在用户管理中修改自己的密码',
  'pages.users.passwordModal.alertTitle': '修改后该用户需要重新登录',
  'pages.users.passwordModal.newPassword.label': '新密码',
  'pages.users.passwordModal.newPassword.placeholder': '请输入新密码',
  'pages.users.passwordModal.newPassword.required': '请输入新密码',
  'pages.users.passwordModal.confirmPassword.label': '确认新密码',
  'pages.users.passwordModal.confirmPassword.placeholder': '请再次输入新密码',
  'pages.users.passwordModal.confirmPassword.required': '请再次输入新密码',
  'pages.users.passwordModal.confirmPassword.mismatch': '两次输入的密码不一致',
  'pages.users.assignModal.title': '为 {name} 授权平台访问',
  'pages.users.assignModal.titleWithoutName': '为用户授权平台访问',
  'pages.users.assignModal.alertTitle': '批量授权说明',
  'pages.users.assignModal.alertDescription': '选择要授权的业务平台，用户将可以通过统一认证登录这些平台。点击标签即可选择。',
  'pages.users.assignModal.selectAll': '全选',
  'pages.users.assignModal.clear': '取消全选',
  'pages.users.assignModal.invert': '反选',
  'pages.users.assignModal.result.assigned': '授权 {count} 个平台',
  'pages.users.assignModal.result.revoked': '撤销 {count} 个平台',
  'pages.users.assignModal.result.failed': '{count} 个操作失败',
  'pages.users.assignModal.emptyPlatforms': '暂无可授权的平台',
  'pages.platforms.title': '平台管理',
  'pages.platforms.searchPlaceholder': '搜索平台名称、标识或 API Key',
  'pages.platforms.actions.create': '添加平台',
  'pages.platforms.actions.edit': '编辑',
  'pages.platforms.actions.regenerate': '重置密钥',
  'pages.platforms.actions.archive': '归档',
  'pages.platforms.updateSuccess': '平台已更新',
  'pages.platforms.createSuccess.title': '平台创建成功',
  'pages.platforms.createSuccess.description': '已为平台自动生成 API 密钥，请妥善保存：',
  'pages.platforms.createSuccess.warning': '关闭后将无法再次查看完整密钥，如遗失需要重新生成。',
  'pages.platforms.archiveConfirm.title': '确认归档平台',
  'pages.platforms.archiveConfirm.content': '确定要归档平台“{name}”吗？归档后将无法在前端选择。',
  'pages.platforms.archiveConfirm.success': '平台已归档',
  'pages.platforms.regenerateConfirm.title': '重新生成 API 密钥',
  'pages.platforms.regenerateConfirm.content': '确定要为平台“{name}”重新生成 API 密钥吗？',
  'pages.platforms.regenerateConfirm.warning': '旧密钥将立即失效，请确保在业务平台中及时更新配置！',
  'pages.platforms.regenerateConfirm.ok': '确认重新生成',
  'pages.platforms.regenerateSuccess.title': 'API 密钥已重新生成',
  'pages.platforms.regenerateSuccess.description': '请妥善保存以下密钥，关闭后将无法再次查看完整密钥：',
  'pages.platforms.table.name': '平台名称',
  'pages.platforms.table.slug': '标识',
  'pages.platforms.table.description': '描述',
  'pages.platforms.table.status': '状态',
  'pages.platforms.table.actions': '操作',
  'pages.platforms.form.editTitle': '编辑平台',
  'pages.platforms.form.createTitle': '添加平台',
  'pages.platforms.form.name.label': '平台名称',
  'pages.platforms.form.name.placeholder': '请输入平台名称',
  'pages.platforms.form.name.required': '请输入平台名称',
  'pages.platforms.form.slug.label': '平台标识',
  'pages.platforms.form.slug.placeholder': '请输入平台标识',
  'pages.platforms.form.slug.required': '请输入平台标识',
  'pages.platforms.form.slug.pattern': '仅支持小写字母、数字和短横线',
  'pages.platforms.form.description.label': '描述',
  'pages.platforms.form.description.placeholder': '请输入描述（可选）',
  'pages.platforms.form.jwtAccessSecret.placeholder': '平台专属的 JWT Access Token 密钥（可选）',
  'pages.platforms.form.jwtRefreshSecret.placeholder': '平台专属的 JWT Refresh Token 密钥（可选）',
  'pages.platforms.form.status.label': '状态',
};
